import React, {useEffect} from "react";
import {
  Card,
  CardBody, CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useMetadata} from "../../../../../../_emywork/AEPagination";
import {actionTypes} from "../../../_redux/Experiences/slice";
import {fetchEntities} from "../../../_redux/Experiences/actions";
import {AESpinner} from "../../../../../../_emywork/spinner/AESpinner";
import {ExperienceForm} from "./ExperienceForm";
import {AEButton} from "../../../../../../_emywork/components/buttons";
import {ModuleProvider, useModuleContext} from "../../../ModuleContext";
import {useIntl} from "react-intl";
import {EducationsContent} from "../educations/Educations";

export function Experiences(props) {

  return (
    <ModuleProvider>
      <ExperiencesContent {...props} />
    </ModuleProvider>
  )
}

export function ExperiencesContent({ history, match: { params: { username }, }}) {
  const dispatch = useDispatch();
  const {openDetailsPage} = useModuleContext();
  const {formatMessage} = useIntl();

  const { entities, meta, isLoading, authUser } = useSelector(
    state => {
      const {entities, meta, isLoading} = state.user_experiences[actionTypes.List]
      const {user: authUser} = state.auth
      return {entities, meta, isLoading, authUser}
    }
    , shallowEqual )
  const metadata = useMetadata(meta);

  const getEntities = () => {
    let md = metadata.toAEMetadata();
    md.pagination.perPage = 100
    md.filters.user_id = authUser.id
    dispatch(fetchEntities(md));
  }

  useEffect(() => {
    getEntities()
  }, [dispatch]);

  return (
    <Card>
      {isLoading && <ModalProgressBar />}
      <CardHeader title={formatMessage({id: "EXPERIENCES"})}>
        <CardHeaderToolbar>
          <AEButton
            variant={'light'}
            className="ml-2"
            onClick={()=>{
              openDetailsPage(username)
            }}
          >
            {formatMessage({id:'PROFILE'})}
          </AEButton>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody className="text-center">
        {
          isLoading ?
            <AESpinner /> :
            <>
              <ExperienceForm
                getEntities={getEntities}
                userId={authUser.id}
              />

              {
                entities.map(e=>(
                  <ExperienceForm
                    key={e.id}
                    entity={e}
                    getEntities={getEntities}
                  />
                ))
              }
            </>
        }
      </CardBody>
    </Card>
  );
}
